<template>
  <div class="p-menus-no-detail__block">
    <h3 class="p-menus-no-detail__block__title c-title2">店舗一覧</h3>
    <div class="p-menu-store-list">
      <div class="p-menu-store-list__areaList">
        <ul class="c-lists">
          <li v-for="(item, i) in viewAreaList" :key="i" class="c-lists__list">
            <p class="c-lists__list__label">
              {{ item.areaLrgClassNm }}
            </p>
            <ul class="c-lists__list__group">
              <li
                v-for="(pref, i) in item.areaMidClassNm"
                :key="i"
                class="c-lists__list__group__item"
                @click="handleClickArea(pref)"
              >
                {{ pref }}
              </li>
            </ul>
          </li>
        </ul>
      </div>

      <div class="p-menu-store-list__lists-header" id="storelist-section">
        <Paginator
          :total="totalCount || 0"
          :size="size"
          @pageChange="pageChange"
        />
      </div>
      <table v-if="viewStoreList.length > 0" class="p-menu-store-list__lists">
        <template v-for="areaGroup in viewStoreList">
          <tr
            v-for="(store, index) in areaGroup.storeItems"
            :key="`${areaGroup.areaName}${store.facilityNm}`"
          >
            <th v-if="index === 0" :rowspan="areaGroup.storeItems.length">
              {{ areaGroup.areaName }}
            </th>
            <td @click="showModal('store-info', store)">
              <p class="p-menu-store-list__lists__title">
                {{ store.facilityNm }}
              </p>
              <p class="p-menu-store-list__lists__address">
                {{ store.facilityAddress }}
              </p>
              <div class="p-menu-store-list__lists__arrow">
                <Icon name="arrow_right" :color="$colors.brand.red" />
              </div>
            </td>
          </tr>
        </template>
      </table>

      <div class="p-menu-store-list__footer">
        <Paginator
          :total="totalCount || 0"
          :size="size"
          @pageChange="pageChange"
        />
      </div>

      <Modal
        ref="store-info"
        width-size="LL"
        title="店舗情報"
        class="p-menu-store-list__modal"
      >
        <!-- 店舗情報 -->
        <div class="p-menu-store-list__modal__block">
          <MenusStoreInfo :store="modalStore" :menu="menu.headerData" />
        </div>

        <!-- 設備・サービス情報 -->
        <MenusFacilityService :facility="modalStore" view="modal" />

        <p
          v-if="modalStore.lastUpdateDate"
          class="p-menu-store-list__modal__date"
        >
          {{ $moment(modalStore.lastUpdateDate).format("YYYY年MM月DD日") }}更新
        </p>

        <p class="p-menu-store-list__modal__attention">
          ［注意事項］
          店舗情報については、更新時点での情報となり、サービス提供企業の都合により現状の情報が異なる場合があります。
        </p>
      </Modal>
    </div>
  </div>
</template>

<script>
import { areaOrder } from "@/utils/localtion.js";
import Paginator from '../Paginator'
import MenusStoreInfo from '../MenusStoreInfo'
import MenusFacilityService from '../MenusFacilityService'
import Modal from '../Modal'
import _ from "lodash";

export default {
  props: {
    areaList: {
      type: Array,
      default: () => []
    },
    pagingList: {
      type: Object,
      default: () => {}
    },
    size: {
      type: Number,
      default: 10
    },
    menu: {
      type: Object,
      default: () => ({})
    }
  },
  components:{
    Paginator,
    MenusStoreInfo,
    MenusFacilityService,
    Modal
  },
  data() {
    return {
      currentPref: null,
      modalStore: {},
      totalCount: this.pagingList?.totalCount || 0
    };
  },
  computed: {
    viewStoreList() {
      if (!this.pagingList?.facilities?.length > 0) return [];
      let result = _.chain(this.pagingList.facilities)
        .groupBy((item) => `${item.areaMidClassNm}／${item.areaSmlClassNm}`)
        .map((value, key) => ({ areaName: key, storeItems: value }))
        .value();
      return result;
    },
    viewAreaList() {
      let result = [];
      for (let item of this.areaList) {
        // areaLrgClassNmが存在しているかチェック
        let isExistsLrgClsNm =
          result.find((v) => v.areaLrgClassNm == item.areaLrgClassNm) || null;

        // areaLrgClassNmが重複していない場合
        if (!isExistsLrgClsNm) {
          result.push({
            areaLrgClassNm: item.areaLrgClassNm,
            areaMidClassNm: [item.areaMidClassNm]
          });

          // areaLrgClassNmが重複している場合areamdClassNmだけ追加していく
        } else {
          let target = result.filter(
            (x) => x.areaLrgClassNm == item.areaLrgClassNm
          );
          target[0].areaMidClassNm.push(item.areaMidClassNm);
        }
      }

      // 都道府県の重複を削除
      for (let i = 0; i < result.length; i++) {
        result[i].areaMidClassNm = Array.from(
          new Set(result[i].areaMidClassNm)
        );
      }
      // 都道府県エリアの順序を入れ替える
      result = result.sort((x, y) => {
        const indexX = areaOrder.indexOf(x.areaLrgClassNm);
        const indexY = areaOrder.indexOf(y.areaLrgClassNm);
        if (indexX < 0) return 1;
        if (indexY < 0) return -1;
        return indexX - indexY;
      });

      return result;
    }
  },
  methods: {
    handleClickArea(areaMidClassNm) {
      this.$emit("clickMidArea", areaMidClassNm);
      this.$scrollTo("#storelist-section");
    },
    prefecturesName(pref) {
      if (!this.$pref.codes[pref] || !this.$pref.codes[pref].name) return "";
      return this.$pref.codes[pref].name;
    },
    pageChange(page) {
      this.$emit("pageChange", page);
    },
    getPrefGroupName(id = null) {
      if (!id) return "";
      return this.$pref.groups[id].name;
    },
    getPrefName(id = null) {
      if (!id) return "";
      return this.$pref.codes[id].name;
    },
    searchPrefArea(id = null) {
      this.$emit("searchPrefArea", id);
      let query = Object.assign({}, this.$route.query);
      let queryParam = {
        ...query,
        pref: id
      };
      if (!id) delete queryParam.pref;
      this.$router.push({ query: queryParam });
    },

    showModal(name, data) {
      this.modalStore = data;
      this.$refs[name].show();
    }
  },
  mounted() {
    this.currentPref = this.$route.query.pref;
  },
  watch: {
    $route() {
      this.currentPref = this.$route.query.pref;
    }
  }
};
</script>

<style lang="scss" scoped>
.c-lists__list__group__item {
  &:hover {
    text-decoration: underline;
    cursor: pointer;
  }
}
@import './style.scss';
</style>
